import React, { useEffect, useMemo, useState, useCallback } from 'react'

import './FeedPage.css'

import UpcomingEvents from './custom-comp/UpcomingEvents'
import { Link, useNavigate } from 'react-router-dom'
import { useRef } from 'react';
import axios from 'axios'
import LiveCardSkeleton from './custom-comp/LiveCardSkeleton'
import FooterAppDownloadModal from './custom-comp/FooterAppDownloadModal'
import BottomFooterModal from './custom-comp/BottomFooterModal'

import { API_BASE_URL } from "../utils";
import UpcomingPlanModal from './custom-comp/UpcomingPlanModal'
import FeedHorizontalScroll from './custom-comp/FeedHorizontalScroll'
import { Helmet } from 'react-helmet-async'
import FeedCardNewEvent from './custom-comp/FeedCardNewEvent'
import FeedCardNewTeaser from './custom-comp/FeedCardNewTeaser'
import FeedPageSideBar from './custom-comp/FeedPageSideBar'
import DirectFullscreenReel from './custom-comp/DirectFullscreenReel'
import CreateFeedModel from './custom-comp/CreateFeedModel'
import FeedCardNew from './custom-comp/FeedCardNew';
import FooterSection from './custom-comp/FooterSection';
import { useInfiniteQuery } from "@tanstack/react-query";
// import { useQuery } from "@tanstack/react-query";
// import { queryClient } from '../queryClient/queryClient'
import referFriend from './image/refer-friend.svg';

import { useGeoLocation } from "../context/LocationContext";
import InviteFriendModal from '../BookingHistory/customComp/InviteFriendModal';

export default function FeedPage() {
  const navigate = useNavigate();
  const { latitude, longitude } = useGeoLocation();


  // const [isLoading, setIsLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [visibleCount, setVisibleCount] = useState(6);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLead, setSelecteLead] = useState(null);
  const [offsetTop, setOffsetTop] = useState(0);
  const [isFullscreenMode, setIsFullscreenMode] = useState(false);
  const [fullscreenStartIndex, setFullscreenStartIndex] = useState(0);
  const [createLeadModel, setCreateLeadModel] = useState(false);

  const [inviteFriendModal, setInviteFriendModal] = useState(false);

  const [limit, setLimit] = useState(10);
  const loaderRef = useRef(null);
  const upcomingRef = useRef(null);
  const itemRefs = useRef({});


  const url = `${API_BASE_URL}/master/assets/uploads/`;
  const feedApiUrl = `${API_BASE_URL}/master/APIs/Common/commonfeedpageapp`;
  const userdata = JSON.parse(localStorage.getItem("userData"));

  const generateClubUrl = useCallback((item) => {
    const { clubName, cityName, areaName, name } = item;
    const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");
    return `/event/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(name)}`;
  }, []);

  // const slicedEvents = events;

  // const [feeds, setFeeds] = useState([]);



  const fetchFeed = async ({ pageParam = 1 }) => {
    const formData = new FormData();
    formData.append("latitude", latitude ?? "");
    formData.append("longitude", longitude ?? "");
    formData.append("page", pageParam);
    formData.append("limit", 10);

    const res = await axios.post(feedApiUrl, formData);

    if (!res.data.status) {
      return { data: [], nextPage: undefined };
    }

    return {
      data: res.data.data,
      nextPage: pageParam < res.data.pagination.pages ? pageParam + 1 : undefined,
    };
  };

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
  } = useInfiniteQuery({
    queryKey: ["feeds", latitude, longitude],
    queryFn: fetchFeed,
    getNextPageParam: (lastPage) => lastPage.nextPage,
    enabled: !!latitude && !!longitude,
    keepPreviousData: true,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });

  const feeds = data?.pages.flatMap(page => page.data) ?? [];


  useEffect(() => {
    if (!loaderRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasNextPage && !isFetchingNextPage) {
          fetchNextPage();
        }
      },
      { threshold: 1 }
    );

    observer.observe(loaderRef.current);
    return () => {
      if (loaderRef.current) observer.unobserve(loaderRef.current);
    };
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);



  // Resize observer for upcoming events
  useEffect(() => {
    if (!upcomingRef.current) return;

    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        setOffsetTop(entry.contentRect.height);
      }
    });

    observer.observe(upcomingRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);





  const renderFeedItem = useCallback((item) => {
    const handleSwitchToFullMode = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setFullscreenStartIndex(item.uniqueIndex);
      setIsFullscreenMode(true);
    };

    const itemRefCallback = (el) => {
      if (el) itemRefs.current[item.uniqueIndex] = el;
    };

    switch (item.component) {
      case 'LiveCardVideo':
        return (
          <div key={item.uniqueIndex} className="reel-item" ref={itemRefCallback}>
            <div className="feed-item-container">
              {item.type === 'event' ? (
                <Link to={generateClubUrl(item.data)}>
                  <FeedCardNewEvent data={item.data} />
                </Link>
              ) : (
                <FeedCardNewTeaser
                  data={item.data}
                //  onFullModeClick={handleSwitchToFullMode} 
                />
              )}
            </div>
          </div>
        );

      case 'LiveCard':
        return (
          <div key={item.uniqueIndex} className="reel-item" ref={itemRefCallback}>
            <div className="feed-item-container">
              {/* <Link to={generateClubUrl(item.data)}> */}
              <FeedCardNewEvent
                data={item?.data}
              // onFullModeClick={handleSwitchToFullMode}
              />
              {/* </Link> */}
            </div>
          </div>
        );

      case 'PackageCard':
        return (
          <div key={item.uniqueIndex} className="available-packages-box">
            <div className="feed-item-container">
              <FeedHorizontalScroll data={item?.data} />
            </div>
          </div>
        );

      case 'GalleryCard':
        return (
          <div key={item.uniqueIndex} className="available-packages-box">
            <div className="feed-item-container">
              <FeedCardNew data={item?.data} />
            </div>
          </div>
        );

      default:
        return null;
    }
  }, [generateClubUrl, setFullscreenStartIndex, setIsFullscreenMode]);

  const handleExitReelMode = () => {
    setIsFullscreenMode(false);

  };

  const [showSideBar, setShowSideBar] = useState(false);


  const handleStartReelMode = () => {
    setFullscreenStartIndex(0);
    setIsFullscreenMode(true);
  };



  return (
    <>


      <Helmet>
        <meta name="description" content="Book the best party venues, bars, cafés, and top lounges near me in Delhi-NCR. Explore options, get offers & deals with PartyWitty's booking platform." />
        <meta name="robots" content="all" />
        <meta name="GOOGLEBOT" content="Index, Follow" />
        <meta name="Robots" content="Index, Follow" />
        <meta name="Author" content="Party witty" />
        <meta name="language" content="EN-UK" />
        <meta
          property="og:title"
          content="Party Packages | Corporate Party Places, Cocktail Party Bar,Pubs"
        />
        <meta property="og:site_name" content="PartyWitty" />
        <meta property="og:url" content="https://www.partywitty.com" />
        <meta
          property="og:description"
          content="Party Witty is a Place for Finding Best Party Packages Near You, Party Venues, Liquor Party Packages  Best Deals & Offers Veg & Non Veg Food, cocktail  Party Bar,pubs, Group party halls in Delhi Ncr."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.partywitty.com/static/media/logo.7b353465feb370797c03.png"
        />
        <link rel="canonical" href=" https://www.partywitty.com/ " />
      </Helmet>

      {/* {isLoading && <p>Loading feeds...</p>}
      {isError && <p>Something went wrong!</p>} */}

      <div className='feed-page'>
        <div className='live-reel-container'>
          <div className='feed-page-pro-section'>
            {/* <FeedProfileSection /> */}
            {/* <FeedPageSideBar /> */}
          </div>

          <div className='live-reel-header'>

            {/* <div className='live-reel-view-full-mode-btn'
            //  onClick={handleFullView}
            >
              <i class="fi fi-rr-expand"></i>
            </div> */}

            {/* <div className='live-reel-header-text-profile-section'>

              <div className='live-reel-header-text'>
                <div className='live-reel-header-image' onClick={() => setCreateLeadModel(true)}>
                  <img
                    src={
                      userdata?.img
                        ? url + userdata.img
                        : "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_1280.png"
                    }
                    alt="user-profile"
                  />
                </div>

                <div className='live-reel-header-text-content-input' onClick={() => setCreateLeadModel(true)}>
                  <input
                    type="search"
                    readOnly
                    placeholder={`What's on your mind ${userdata?.name ? userdata?.name : ''}?`}
                  />
                  <i class="in-mobile-view-only fi-rr-picture feed-profile-icon"></i>
                </div>

                <div className='live-reel-header-text-icon-mobile'>
                  <i class="fi fi-sr-menu-burger feed-profile-icon-mobile-burger" onClick={() => setShowSideBar(true)}></i>
                </div>

                <div className={`feed-page-sidebar ${showSideBar ? 'active' : ''}`}>
                  <div className='feed-page-sidebar-content'>
                    <FeedPageSideBar setShowSideBar={setShowSideBar} />
                  </div>
                </div>
                {showSideBar && (
                  <div
                    className='feed-page-sidebar-overlay'
                    onClick={() => setShowSideBar(false)}
                  ></div>
                )}


              </div>


              <div className='live-reel-header-text-icon-section'>
                <div className='lrhtis-icons blue-image' onClick={() => setCreateLeadModel(true)}><i class=" fi-rr-picture feed-profile-icon"></i>image</div>
                <div className='lrhtis-icons green-image' onClick={() => setCreateLeadModel(true)}><i class=" fi-br-video-camera-alt feed-profile-icon"></i>video</div>
                <div className='lrhtis-icons voilet-image' onClick={() => setCreateLeadModel(true)}><i class=" fi-rr-edit feed-profile-icon"></i>write text</div>
              </div>
            </div> */}


            <div className="live-reel">
              {/* Initial load skeletons */}
              {feeds.length === 0 && isLoading ? (
                Array.from({ length: 4 }).map((_, i) => <LiveCardSkeleton key={i} />)
              ) : (
                <>
                  {/* Render feed items */}
                  {feeds.map((item, index) =>
                    renderFeedItem(item, index)
                  )}

                  {isFetchingNextPage &&
                    Array.from({ length: 3 }).map((_, i) => (
                      <LiveCardSkeleton key={`loading-${i}`} />
                    ))}
                  {/* Loader placeholder for infinite scroll */}
                  <div ref={loaderRef} style={{ height: "40px", textAlign: "center" }}>

                    {!hasNextPage && !isFetchingNextPage && feeds.length > 0 && (
                      <p>No more data 🎉</p>
                    )}
                  </div>
                </>
              )}
            </div>

          </div>

          <div className='f-upcoming-events-section' style={{ position: 'sticky', top: `${48}px`, zIndex: 2 }}>
            <div ref={upcomingRef} style={{ display: 'block', width: '100%' }}>
              <UpcomingEvents setModalOpen={setModalOpen} setSelecteLead={setSelecteLead} />
            </div>

            {userdata !== null &&
            <div className='upcoming-events-referr-a-friend-feed-page-mobile'>
              <div className='upcoming-events-referr-a-friend' style={{ backgroundImage: `url(${referFriend})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundOpacity: '0.7' }}>
                <h3>Refer & Earn</h3>
                <p>Share the party vibes with your friends and collect carrots every time they join in. More carrots = more savings on your next night out! </p>
                <button onClick={() => setInviteFriendModal(true)}>Invite Friend</button>
              </div>
              </div>
            }

            <div className="fues-footer-sec-line">
              <FooterSection />
            </div>
          </div>
        </div>

        <div className='feed-page-design-bottom-footer-tags-section'>
          <div className='feed-page-detail-page-design-bottom-footer-tags'>
            <div className='feed-page-detail-page-design-bottom-footer-tags-text'>
              <h1>Book the Best Party Venues, Bars, Cafes & Lounges in Delhi-NCR</h1>
              <p>Top-rated party venues, bars, cafés, and lounges in Delhi, Noida, and Gurgaon for birthdays, corporate parties, kitty parties, and weekend hangouts. Whether you're looking for rooftop lounges, live music cafés, dance floors, or themed party halls, find the perfect place that fits your vibe and budget. Compare packages, explore curated party deals, and book instantly with PartyWitty. Enjoy exclusive offers on private party spaces, couple-friendly lounges, and group bookings across Delhi-NCR. Make your celebrations memorable by booking verified venues with custom food and drink options. Plan your next party effortlessly with our trusted event booking platform. </p>
            </div>
            <div className='feed-page-detail-page-design-bottom-footer-tags-text'>
              <h1>Book a Table Instantly at Restaurants, Clubs & Pubs Near You with the Best Offers</h1>
              <p>Book a table instantly at the best restaurants, clubs, and pubs near you with PartyWitty. Whether it's a birthday, anniversary, corporate event, or casual night out, find the perfect venue that suits your vibe. Explore top-rated places across Delhi-NCR, compare deals, check availability, and reserve your spot in just a few clicks. Get access to exclusive table booking offers and save up to 50% on your party experience. From rooftop lounges to BYOB venues, PartyWitty helps you plan the perfect outing without the hassle. Book now and party your way — effortlessly and affordably.</p>
            </div>
            <div className='feed-page-detail-page-design-bottom-footer-tags-text'>
              <h1> Explore Custom Party Packages with Exclusive Deals & Offers</h1>
              <p>Planning a celebration? PartyWitty helps you explore and book custom party packages at top restaurants, clubs, and lounges across Delhi, Noida, and Gurgaon. Whether it's a birthday, anniversary, corporate event, or a casual get-together, find the perfect venue that suits your style and budget. Get up to 50% off on exclusive deals, including rooftop lounges, BYOB venues, and dance floors. Customize food and drink menus, check real-time availability, and compare verified listings — all in one place. With PartyWitty, party planning becomes quick, flexible, and effortless. Book now and enjoy unforgettable moments stress-free!</p>
            </div>
          </div>
        </div>

        <FooterAppDownloadModal isOpen={showModal} onClose={() => setShowModal(false)} />
        <BottomFooterModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        <UpcomingPlanModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          selectedLead={selectedLead}
        />
        <DirectFullscreenReel
          isOpen={isFullscreenMode}
          onClose={handleExitReelMode}
          feeds={feeds}
          renderFeedItem={renderFeedItem}
          initialIndex={fullscreenStartIndex}
          visibleCount={visibleCount}
          setVisibleCount={setVisibleCount}
        />

        <CreateFeedModel open={createLeadModel} onClose={() => setCreateLeadModel(false)} />
        <InviteFriendModal isOpen={inviteFriendModal} onClose={() => setInviteFriendModal(false)} />

      </div>
    </>
  )
}